// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SuccessOnboarding_wrapper__3Gcm_","title":"SuccessOnboarding_title__1ZYCV","caption":"SuccessOnboarding_caption__bhCUC","imageLogo":"SuccessOnboarding_imageLogo__2bDuK"};